/**
 * Handles failed lazy-loaded chunks (e.g. after a deploy: cached index.html still points at old hashed files).
 * Registers global listeners only; does not change routing or data flow.
 *
 * Loop guard: if the navigation that loaded this page was already a reload, do not reload again.
 */

function isChunkLoadFailure(message, error) {
  const parts = [message, error?.message, error?.name, String(error ?? '')]
    .filter(Boolean)
    .join(' ');
  return (
    /ChunkLoadError/i.test(parts) ||
    /Loading chunk [\w-]+ failed/i.test(parts) ||
    /Failed to fetch dynamically imported module/i.test(parts) ||
    /error loading dynamically imported module/i.test(parts) ||
    /Importing a module script failed/i.test(parts)
  );
}

function navigationWasReload() {
  try {
    const nav = performance.getEntriesByType?.('navigation')?.[0];
    if (nav && nav.type === 'reload') {
      return true;
    }
    // Deprecated but still present on some WebKit versions
    if (performance.navigation?.type === performance.navigation.TYPE_RELOAD) {
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

function recoverChunkLoad() {
  if (navigationWasReload()) {
    console.warn(
      '[chunkLoadRecovery] Chunk load failed after a reload; skipping another reload to avoid a loop.'
    );
    return;
  }
  console.warn(
    '[chunkLoadRecovery] Stale or missing chunk detected; reloading once to fetch fresh assets.'
  );
  window.location.reload();
}

window.addEventListener(
  'error',
  (event) => {
    if (isChunkLoadFailure(event.message, event.error)) {
      event.preventDefault();
      recoverChunkLoad();
    }
  },
  true
);

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  if (isChunkLoadFailure('', reason)) {
    event.preventDefault();
    recoverChunkLoad();
  }
});
